import { Box, Button } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const MemberJoinUs = () => {
  const navigate = useNavigate();
  const handleLogin = () => {
    navigate("/login");
  };
  return (
    <Box
      id="become-member"
      className="about-section p-5"
      sx={{
        // background: "linear-gradient(to right, #ffd194, #70e1f5)",
        // background: '#333333',
        // background: '-webkit-linear-gradient(to bottom, #dd1818, #333333)',
        // background: 'linear-gradient(to bottom, #dd1818, #333333)',
        background: "#000",
        py: 5,
      }}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-8 col-md-8 col-sm-12 col-12">
            <div className="abt-div">
              <h3 className="abt-title">
                Youth Forum – Active catalyst of change
              </h3>
              <p>
                We are launching Youth Forums in every village to empower young
                minds, foster collaboration, and instill civic responsibility.
                Each forum will consist of 20 dedicated members who will work
                together on community-driven initiatives while also setting
                personal goals for growth. These forums will focus on key areas
                such as cleanliness drives, education awareness,
                entrepreneurship, and digital literacy, ensuring holistic
                development. Members will have the opportunity to develop
                leadership skills, contribute to real projects, and enhance
                their personal and career growth.
              </p>
              <p>
                By working towards both group and individual goals, the youth
                will play an active role in shaping a better future for their
                village.
              </p>
              <p>
                This initiative aims to build a strong network of changemakers
                who take responsibility for their surroundings and inspire
                others. Through collaboration and action, we can transform our
                villages into progressive, self-sustained communities led by
                motivated young individuals.
              </p>
              <Button
                variant="contained"
                color="success"
                onClick={handleLogin}
                className="abt-btnn mb-3"
              >
                Join Now
              </Button>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-12">
            <img src="/images/about-img.webp" alt="" className="abt-img" />
          </div>
        </div>
      </div>
    </Box>
  );
};

export default MemberJoinUs;
